import { render } from "./DirectoryNav.vue?vue&type=template&id=01f38921&scoped=true"
import script from "./DirectoryNav.vue?vue&type=script&lang=js"
export * from "./DirectoryNav.vue?vue&type=script&lang=js"

import "./DirectoryNav.vue?vue&type=style&index=0&id=01f38921&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3953904547/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f38921"]])

export default __exports__